// Shared validation without browser or database dependencies (Node 12 compatible).
function validateTaskForm(value, validateCron) {
    const errors = {};
    if (!String(value.name || '').trim()) errors.name = 'Введите название задачи.';
    else if (String(value.name).length > 255) errors.name = 'Название должно быть не длиннее 255 символов.';
    if (!value.responsible || !Number.isInteger(Number(value.responsible.user_id)) || Number(value.responsible.user_id) <= 0) {
        errors.responsible = 'Выберите ответственного.';
    }
    if (![0, 1, '0', '1'].includes(value.status)) errors.status = 'Выберите статус задачи.';
    if (value.controlPoints !== undefined && (!Array.isArray(value.controlPoints) || value.controlPoints.some(point => !point.due_at || !Number.isFinite(new Date(point.due_at).getTime()) || value.endDate && new Date(point.due_at) > new Date(value.endDate)))) {
        errors.controlPoints = 'Проверьте даты контроля: каждая должна быть заполнена и не позднее срока задачи.';
    }
    if (value.endDate) {
        if (!Number.isFinite(new Date(value.endDate).getTime())) errors.endDate = 'Укажите корректный срок.';
        if (value.repeatCron) errors.repeatCron = 'Выберите один вариант: срок или повтор.';
        if (value.controlDate && (!Number.isFinite(new Date(value.controlDate).getTime()) || new Date(value.controlDate) > new Date(value.endDate))) {
            errors.controlDate = 'Контрольная дата должна быть не позднее срока задачи.';
        }
    } else {
        if (!value.repeatCron) errors.endDate = 'Укажите срок или настройте повтор.';
        else {
            try {
                if (!/^\S+(?:\s+\S+){4,5}$/.test(value.repeatCron.trim())) throw new Error();
                if (validateCron) validateCron(value.repeatCron);
            } catch (e) { errors.repeatCron = 'Проверьте расписание повторов.'; }
        }
        if (value.controlDate) errors.controlDate = 'Контрольная дата доступна для разовой задачи.';
    }
    return errors;
}
module.exports = {validateTaskForm};
